<template>
  <v-card tile :min-height="$vuetify.breakpoint.height / 2">
    <v-card-title class="d-flex align-center">
      <v-row class="d-flex align-center justify-space-between ma-0 pa-0">
        <v-col cols="5" class="ma-0">
          <span>{{$t('admin.dashboard.requests')}}</span>
        </v-col>
        <v-col cols="3" class="ma-0">
          <v-select :label="visitInfo.label"
                    v-model="date"
                    item-value="value"
                    :placeholder="visitInfo.placeholder"
                    @change="getVisits"
                    :items="visits"></v-select>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
                    :loading="$store.getters.GET_LOADING"
                    :items="requests"
                    :headers="headers"
                    :expanded.sync="expanded"
                    :single-expand="single"
                    :fixed-header="true"
                    :items-per-page="5"
                    :search="search"
                    item-key="country_name"
                    show-expand>
        <template v-slot:top>
          <v-toolbar flat>
                <v-text-field
                  class="mt-n5"
                  v-model="search"
                  :label="$t('admin.dashboard.search')"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-select :label="$t('admin.dashboard.infoTable.groupBy')"
                          :items="groups"
                          v-model="groupBy"></v-select>
                <v-spacer></v-spacer>
                <v-switch v-model="single"
                          :label="$t('admin.dashboard.single')"
                          class="mt-2"></v-switch>
          </v-toolbar>
        </template>
        <template v-slot:item.flag="{ item }">
          <v-img class="elevation-2"
                 :src="item.flag"
                 :max-width="24"></v-img>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="pa-0" :colspan="headers.length">
            <v-data-table
              fixed-header
              :headers="infoHeaders"
              :items="item.cities"
              :group-by="groupBy"
              disable-pagination
              hide-default-footer
              height="300"
            >
              <template v-slot:group.header="{items, isOpen, toggle}">
                  <td :colspan="infoHeaders.length">
                    <v-icon @click="toggle"
                    >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                    {{ items[0][groupBy] }}
                  </td>
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'InfoTableComponent',
  data () {
    return {
      search: '',
      expanded: [],
      single: false,
      groupBy: null,
      date: 7
    }
  },
  methods: {
    async getVisits () {
      await this.$store.dispatch('setLoading', true)
      await this.$http.get(`api/v2/auth/regions/grouped/${this.date}`)
        .then(response => {
          this.requests = response.data.requests
        })
        .finally(() => {
          this.$store.dispatch('setLoading', false)
        })
    }
  },
  computed: {
    headers () {
      return this.$t('admin.dashboard.infoTable.headers')
    },
    infoHeaders () {
      return this.$t('admin.dashboard.infoTable.infoHeaders')
    },
    groups () {
      return this.$t('admin.dashboard.infoTable.groups')
    },
    requests: {
      get () {
        return this.$store.getters.GET_STATISTIC.requests ? this.$store.getters.GET_STATISTIC.requests : []
      },
      set (value) {
        this.$store.getters.GET_STATISTIC.requests = value
      }
    },
    websites () {
      return this.$t('admin.dashboard.websites')
    },
    visitInfo () {
      return this.$t('admin.dashboard.visit')
    },
    visits () {
      return this.$t('admin.dashboard.visits')
    }
  }
}
</script>

<style scoped>

</style>
